import { render, staticRenderFns } from "./CourseAreaCard.vue?vue&type=template&id=9400ebc8&scoped=true&"
import script from "./CourseAreaCard.vue?vue&type=script&lang=js&"
export * from "./CourseAreaCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseAreaCard.vue?vue&type=style&index=0&id=9400ebc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9400ebc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
